module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('modal', {
    attrs: {
      "name": "stats-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h1', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.info")))]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.statisticsUrl
    }
  })])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "props-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h1', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.attributes")))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', _vm._l((_vm.popupAttributes), function(attr) {
    return _c('tr', {
      key: attr.id
    }, [_c('th', [_vm._v(_vm._s(attr.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(attr.value))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "ol-popup",
    attrs: {
      "id": "popup"
    }
  }, [_c('a', {
    staticClass: "ol-popup-closer",
    attrs: {
      "href": "#",
      "id": "popup-closer"
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "popup-content"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.moreData")))]), _vm._v(" "), _vm._l((_vm.statisticsConfs), function(stat, i) {
    return _c('li', {
      key: i,
      staticClass: "statsLink",
      on: {
        "click": function($event) {
          return _vm.showStatistics(stat, _vm.statisticsFeatures[i])
        }
      }
    }, [_vm._v(_vm._s(_vm.statisticsLabels[i]))])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfc7ef4e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatureInfo.vue
// module id = 641
// module chunks = 2